import React, { useEffect } from 'react';
import { VLink } from "./AppDataContext";
import { Helmet } from "react-helmet";

export function Sell() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <main>
            <Helmet>
                <title>Sell on Bid Next Door</title>
            </Helmet>
            <section class="seller">
                <div class="container">
                    <div class="row align-items-center py-5">

                        <div class="col col-md-8 seller--content">
                            <div class="mx-auto py-3 px-3 py-md-5 px-md-5 seller--content__div">
                                <h4>Sell on Bid Next Door</h4>
                                <h1>Bid Next Door® is industry leading auction software.</h1>
                                <div class="ps-3 seller--content__desc">
                                    <p>Our system has been designed with input from Auctioneers, Bidders, Photographers, Operations, and Logistics Experts to make every step of the sale process faster and easier. </p>
                                    <p>By combining a fun and intuitive bidding experience with unparalleled Auction, Inventory Management, Payment and Release features, Bid Next Door® gives you the tools and insights you need to manage and grow your business. </p>
                                </div>
                                <VLink to="/contact" class="btn btn-fill btn-secondary mb-3">Contact Us</VLink>
                            </div>
                        </div>
                        <div class="col seller--image justify-content-center">
                            <img src="images/top-banner-vector.png" alt="" title="" class="w-100" />
                        </div>
                    </div>
                </div>
            </section>
            <section class="">
                <div class="container py-5">
                    <h2 class="text-center position-relative location-search">
                        For Bidders
                        <div class="divider"></div>
                    </h2>
                    <div class="row">


                        <div class="col-12 col-sm-6 col-md-4 mb-4">
                            <div class="grid--item p-3">
                                <img class="d-block mx-auto w-50 mb-3" src="images/picture-prefect-design.png" alt="Picture Perfect Design" title="Picture Perfect Design" />
                                <h3 class="mb-3">Picture Perfect Design</h3>
                                <ul>
                                    <li>Bid Next Door® engages bidders with large, high-quality images sitewide. </li>
                                    <li>Infinite Scroll presents the total content of your auctions. </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-4">
                            <div class="grid--item p-3">
                                <img class="d-block mx-auto w-50 mb-3" src="images/delightful-bidding.png" alt="Delightful Bidding Experience" title="Delightful Bidding Experience" />
                                <h3 class="mb-3">Delightful Bidding Experience</h3>
                                <ul>
                                    <li>BidBump™ and BidFlash™ technologies.</li>
                                    <li>Lightning-fast bidding response time.</li>
                                    <li>"Soft Close" automated timer extensions</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-4">
                            <div class="grid--item p-3">
                                <img class="d-block mx-auto w-50 mb-3" src="images/advanced-notification-system.png" alt="Advanced Notification System" title="Advanced Notification System" />
                                <h3 class="mb-3">Advanced Notification System</h3>
                                <ul>
                                    <li>Built in Favorites, Follow and Bid Notification system for searches, auctioneers, and more - with no limitations!</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="">
                <div class="container py-5">
                    <h2 class="text-center position-relative location-search">
                        For Sellers
                        <div class="divider"></div>
                    </h2>
                    <div class="row">

                        <div class="col-12 col-sm-6 col-md-4 mb-4">
                            <div class="grid--item p-3">
                                <img class="d-block mx-auto w-50 mb-3" src="images/brand-focus.png" alt="Brand Focus" title="Brand Focus" />
                                <h3 class="mb-3">Brand Focus</h3>
                                <ul>
                                    <li>Bid Next Door® has been designed with your brand in mind, keeping your name and company logo at the forefront of all bidder interactions.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-4">
                            <div class="grid--item p-3">
                                <img class="d-block mx-auto w-50 mb-3" src="images/perfectly-timed.png" alt="Perfectly Timed Auctions" title="Perfectly Timed Auctions" />
                                <h3 class="mb-3">Perfectly Timed Auctions</h3>
                                <ul>
                                    <li>Adaptable and expandable network; never have your auction time changed due to system limitations.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-4">
                            <div class="grid--item p-3">
                                <img class="d-block mx-auto w-50 mb-3" src="images/complete-inventory.png" alt="Complete Inventory Management" title="Complete Inventory Management" />
                                <h3 class="mb-3">Complete Inventory Management</h3>
                                <ul>
                                    <li>Web-based inventory creation, tracking, search, tagging, editing, and more!</li>
                                    <li>Unique inventory numbers help you stay organized.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-4">
                            <div class="grid--item p-3">
                                <img class="d-block mx-auto w-50 mb-3" src="images/quick-and-easy-auction-builder.png" alt="Quick & Easy Auction Builder" title="Quick & Easy Auction Builder" />
                                <h3 class="mb-3">Quick &amp; Easy Auction Builder</h3>
                                <ul>
                                    <li>Our visual interactive auction builder allows you to compile inventory items into a ready-to-publish auction in just minutes.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-4">
                            <div class="grid--item p-3">
                                <img class="d-block mx-auto w-50 mb-3" src="images/automated-invoicing-payments.png" alt="Automated Invoicing & Payments" title="Automated Invoicing & Payments" />
                                <h3 class="mb-3">Automated Invoicing &amp; Payments</h3>
                                <ul>
                                    <li>Automated invoice creation.</li>
                                    <li>Batch invoice credit card processing.</li>
                                    <li>Sales Tax editing and reporting.</li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-12 col-sm-6 col-md-4 mb-4">
                            <div class="grid--item p-3">
                                <img class="d-block mx-auto w-50 mb-3" src="images/simple-competetive-pricing.png" alt="Simple & Competetive Pricing" title="Simple & Competetive Pricing" />
                                <h3 class="mb-3">Simple &amp; Competetive Pricing</h3>
                                <ul>
                                    <li>No sign-up fees</li>
                                    <li>$29 Per Month</li>
                                    <li>2% of sold items or $75 whichever is greater</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="seller">
                <div class="container">
                    <div class="row align-items-center ">
                        <div class="col-12 ">                                               
                            <iframe src="https://forms.monday.com/forms/embed/0589e5eb000b24baf35615e2b67aa6ac?r=use1" width="100%" height="945" style={{ border: '0' }}></iframe>

                        </div></div>
                </div>
            </section>
            <section class="seller">
                <div class="container">
                    <div class="row align-items-center py-5">
                        <div class="col seller--image justify-content-center">
                            <img src="images/signupfee-banner.png" alt="" title="" class="mx-auto w-100" />
                        </div>
                        <div class="col col-md-8 seller--content">
                            <div class="mx-auto py-3 px-3 py-md-5 px-md-5 seller--content__div">
                                <h4>No Signup Fee!</h4>
                                <h2>Account Pricing $29 Per Month</h2>
                                <div class="ps-3 seller--content__desc">
                                    <p>Auction Pricing 2% of sales or $75 per auction, whichever is greater.</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </section>
            
        </main>


    );

}
